export default __webpack_public_path__ + "static/media/arvind new (2).46ac87ee.png";